<div class="profile-container">
  <div class="">
    <div class="profile-content">
      <div class="personal-details">
        <div class="header-block">
          <div class="header-title">
            <app-breadcrumb></app-breadcrumb>
          </div>
          <div class="add-block">
            <div class="view-toggle-wrapper custom-toggle-group" style="margin-right: 15px;">
              <button type="button" class="custom-toggle-btn" [class.active-toggle]="viewMode === 'table'"
                (click)="setViewMode('table')">Table</button>
              <button type="button" class="custom-toggle-btn" [class.active-toggle]="viewMode === 'card'"
                (click)="setViewMode('card')">Card</button>
              <button type="button" class="custom-toggle-btn" [class.active-toggle]="viewMode === 'map'"
                (click)="setViewMode('map')">Map</button>
            </div>
            <div class="search">
              <form autocomplete="off">
                <input type="text" (keyup.enter)="getObjectInfoByWildSearch()" [ngModelOptions]="{standalone: true}"
                  [(ngModel)]="searchFilter" placeholder="Search Assets...">
              </form>
              <i class="bi bi-search" (click)="getObjectInfoByWildSearch()"></i>
            </div>
            <div class="filter-icon">
              <i class="bi bi-funnel" [class.active-filter]="showFilter" title="Filter" (click)="toggleFilter()"></i>
              <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshTickets()"></i>
            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 table-data" [ngClass]="{'col-lg-9 col-md-9 ': showFilter}">
            <ng-container *ngIf="viewMode === 'table'">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="width: 15%;">{{ 'object-info.objectInfoId' | translate }}</th>
                    <th style="width: 15%;">{{ 'object-info.givenName' | translate }}</th>
                    <th style="width: 15%;">{{ 'object-info.zone' | translate }}</th>
                    <th style="width: 15%;">{{ 'object-info.city' | translate }}</th>
                    <th style="width: 15%;">{{ 'object-info.country' | translate }}</th>
                    <th style="width: 15%;">{{ 'object-info.objectCondition' | translate }}</th>
                    <th style="width: 10%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate }}
                    </th>
                  </tr>
                </thead>
              </table>
              <div *ngIf="!isLoading">
                <div class="data-view" id="{{list.id}}"
                  [ngClass]="{ 'delete-highlight': list.objectInfoId == recordId }" *ngFor="let list of objectInfoList | paginate : {
                itemsPerPage: tableSize,
                currentPage: page,
                totalItems: count
              }  ;let i = index">

                  <p style="width: 15%;">{{list.objectInfoId}}</p>
                  <p style="width: 15%;" title="{{list.givenName}}">{{list.givenName || '--'}}</p>
                  <p style="width: 15%;">{{list.zone || '--'}}</p>
                  <p style="width: 15%;">{{list.city || '--'}}</p>
                  <p style="width: 15%;">{{list.country || '--'}}</p>
                  <p style="width: 15%;">{{list.objectCondition || '--'}}</p>
                  <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                    <i data-toggle="modal" title="View and Repair" (click)="getObjectInfoById(list.objectInfoId)"
                      data-target="#viewModal" class="bi bi-eye-fill"></i>
                    <i (click)="selectDelete(list.id,list)" title="Delete" class="bi bi-trash" data-toggle="modal"
                      data-target="#deleteModal"></i>
                  </p>
                </div>
              </div>

              <div class="loader" *ngIf="isLoading">
                <div class="spinner"></div>
              </div>

              <div class="loader" *ngIf="!isLoading && objectInfoList.length == 0">
                <div class="no-data">
                  <img src="assets/no-data-6.png" alt="">
                  <p>no data found</p>
                </div>

              </div>

              <div class="paginator">
                <p-paginator #paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
                  [totalRecords]="count" [showFirstLastIcon]="true" [showCurrentPageReport]="true"
                  [showPageLinks]="true" [showJumpToPageDropdown]="false"
                  currentPageReportTemplate="{first} - {last} of {totalRecords}">
                </p-paginator>
              </div>
            </ng-container>

            <ng-container *ngIf="viewMode === 'card'">
              <div class="card-view-container custom-card-view-container">
                <div class="card-pagination custom-card-pagination">
                  <button class="btn btn-sm custom-card-pagination-btn" (click)="prevCardPage()"
                    [disabled]="cardCurrentPage === 1">
                    <i class="bi bi-chevron-left"></i> Previous
                  </button>
                  <button class="btn btn-sm custom-card-pagination-btn" (click)="nextCardPage()"
                    [disabled]="cardCurrentPage * cardsPerPage >= objectInfoList.length">
                    Next <i class="bi bi-chevron-right"></i>
                  </button>
                </div>
                <div class="row">
                  <div class="col-md-3 col-lg-3 col-xl-3 mb-4 custom-card-col" *ngFor="let list of paginatedCards">
                    <div class="card h-100 custom-asset-card-minimal"
                      [ngClass]="{ 'border border-danger': list.objectInfoId == recordId }" data-toggle="modal"
                      title="View Details" (click)="getObjectInfoById(list.objectInfoId)" data-target="#viewModal">

                      <!-- Image as Header -->
                      <div class="custom-card-header position-relative">
                        <img [src]="list.icon || 'assets/img/dummy.png'" alt="Asset Icon" class="custom-card-img">
                        <!-- Top-left: Asset ID badge -->
                        <span class="badge position-absolute custom-badge-id">
                          {{list.objectInfoId || 'ID N/A'}}
                        </span>
                        <!-- Top-right: Asset Condition badge -->
                        <span class="badge position-absolute custom-badge-condition">
                          {{list.objectCondition || 'UNKNOWN'}}
                        </span>
                      </div>

                      <!-- Card Body -->
                      <div class="card-body d-flex flex-column custom-card-body">

                        <!-- Main Title (Asset Name) -->
                        <h5 class="card-title text-truncate custom-card-title" title="{{list.givenName}}">
                          {{list.givenName || 'Unnamed Asset'}}
                        </h5>

                        <!-- Bottom Footer -->
                        <div class="custom-card-footer">

                          <!-- Left side: Created Date -->
                          <div class="footer-item" title="Created Date">
                            <i class="bi bi-calendar-event footer-icon"></i>
                            <span class="custom-text-truncate">{{ list.createdDate ? (list.createdDate |
                              date:'mediumDate') : 'Date N/A' }}</span>
                          </div>

                          <!-- Right side: Location -->
                          <div class="footer-item footer-item-right"
                            title="{{list.location || list.zone || 'Location N/A'}}">
                            <i class="bi bi-geo-alt footer-icon"></i>
                            <span class="custom-text-truncate">{{list.location || list.zone || 'Location N/A'}}</span>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="loader" *ngIf="isLoading">
                  <div class="spinner"></div>
                </div>
                <div *ngIf="paginatedCards.length === 0 && !isLoading" class="text-center mt-4">
                  <p class="text-muted">No records found.</p>
                </div>
              </div>
            </ng-container>

            <button id="hiddenViewModalBtn" data-toggle="modal" data-target="#viewModal"
              style="display: none;"></button>
            <div id="map" [hidden]="viewMode !== 'map'">
            </div>

          </div>
          <div class="col-lg-3 col-md-3" *ngIf="showFilter">
            <div class="customerList">

              <div class="header"
                style="display: flex; justify-content: space-between; align-items: center; padding-right: 10px;">
                <p *ngIf="!showLocationList">Asset Template List</p>
                <p *ngIf="showLocationList">Location List</p>
                <i class="bi bi-geo-alt"
                  style="cursor: pointer; font-size: 1.1rem; padding: 5px 8px; background-color: #f8f9fa; border: 1px solid #dee2e6; border-radius: 6px; transition: all 0.2s;"
                  title="Toggle Location List" (click)="showLocationList = !showLocationList"
                  onmouseover="this.style.backgroundColor='#e9ecef'"
                  onmouseout="this.style.backgroundColor='#f8f9fa'"></i>
              </div>

              <!-- <p (click)="selectAllGeo()">
                  <input type="checkbox" [checked]="selectAllChecked">
                  Select All
              </p> 
              -->
              <div class="list" *ngIf="!showLocationList">
                <p (click)="getObjectInfoByTemplateNameAndLocations(list.templateName)"
                  *ngFor="let list of objectTemplateList" [class.active-item]="selectedTemplate === list.templateName">
                  <span>{{list.templateName}} - ({{list.counts || 0}})</span>
                  <i *ngIf="selectedTemplate === list.templateName" class="bi bi-check-circle-fill active-icon"></i>
                </p>
              </div>

              <div class="select-all-actions" *ngIf="showLocationList"
                style="display: flex; justify-content: space-between; align-items: center; padding: 15px 5px 15px 5px; margin-bottom: 5px;">
                <span (click)="selectAllLocations()"
                  style="cursor: pointer; color: #0d6efd; display: flex; align-items: center; gap: 6px; transition: opacity 0.2s;">
                  <i class="bi bi-check2-all" style="font-size: 1.1rem;"></i> Select All
                </span>
                <span (click)="unselectAllLocations()"
                  style="cursor: pointer; color: #dc3545; display: flex; align-items: center; gap: 6px; transition: opacity 0.2s;">
                  <i class="bi bi-x-circle" style="font-size: 0.9rem;"></i> Clear All
                </span>
              </div>

              <div class="list" *ngIf="showLocationList">
                <p (click)="toggleLocationSelection(loc)" *ngFor="let loc of userLocations"
                  [class.active-item]="selectedLocations.includes(loc)">
                  <span>{{loc}}</span>
                  <i *ngIf="selectedLocations.includes(loc)" class="bi bi-check-circle-fill active-icon"></i>
                </p>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
          <span data-dismiss="modal">
            <i class="bi bi-x-lg" (click)="closeModal()"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}} (ID: {{recordId}})”</span>?
        </p>
        <div class="modal-footer">
          <button type="button" id="deleteModalButton1" (click)="closeModal()" class="btn btn-secondary"
            data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
          <button type="button" (click)="deleteAsset()" class="btn btn-primary">{{ 'generic.delete' | translate
            }}</button>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="viewModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'object-info.headings.detail' | translate }}
          <span class="header-action">
            <i class="bi bi-x-lg" data-dismiss="modal" (click)="remove()"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div class="service-data" *ngFor="let viewData of singleObjectInfoData">
          <div class="form-group">
            <div class="row">
              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.objectInfoId' | translate }} :</label>
                <p>{{viewData.objectInfoId || '--'}}</p>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.name' | translate }} :</label>
                <p>{{viewData.name || '--'}}</p>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.givenName' | translate }} :</label>
                <p>{{viewData.givenName || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.serialNumberCheckBox">
                <label>{{ 'object-info.serialNumber' | translate }} :</label>
                <p>{{viewData.serialNumber || '--'}}</p>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.group' | translate }} :</label>
                <p>{{viewData.group || '--'}}</p>
              </div>
              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.type' | translate }} :</label>
                <p>{{viewData.type || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.modelCheckBox">
                <label>{{ 'object-info.model' | translate }} :</label>
                <p>{{viewData.model || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.makeCheckBox">
                <label>{{ 'object-info.make' | translate }} :</label>
                <p>{{viewData.make || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.objectCondition' | translate }} :</label>
                <p>{{viewData.objectCondition || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>Asset Status :</label>
                <p>{{viewData.assetStatus || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.originalCostCheckBox">
                <label>{{ 'object-info.originalCost' | translate }} :</label>
                <p>{{viewData.originalCost || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.currentCostCheckBox">
                <label>{{ 'object-info.currentCost' | translate }} :</label>
                <p>{{viewData.currentCost || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.branchCheckBox">
                <label>{{ 'object-info.branch' | translate }} :</label>
                <p>{{viewData.branch || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.departmentCheckBox">
                <label>{{ 'object-info.department' | translate }} :</label>
                <p>{{viewData.department || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.location' | translate }} :</label>
                <p>{{viewData.location || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.country' | translate }} :</label>
                <p>{{viewData.country || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.provinceOrState' | translate }} :</label>
                <p>{{viewData.provinceOrState || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.zone' | translate }} :</label>
                <p>{{viewData.zone || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.postalCode' | translate }} :</label>
                <p>{{viewData.postalCode || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.city' | translate }} :</label>
                <p>{{viewData.city || '--'}}</p>
              </div>


              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.createdDate' | translate }} :</label>
                <p>{{viewData.createdDate | date}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.acquisitionDate' | translate }} :</label>
                <p>{{viewData.acquisitionDate || '--'}}</p>
              </div>

              <!-- <div class="col-md-6 col-lg-6" *ngIf="viewData.depreciationCheckbox">
                <label>{{ 'object-info.salvageValue' | translate }} :</label>
                <p>{{viewData.salvageValue || '--'}}</p>
              </div> -->

              <div class="col-md-6 col-lg-6" *ngIf="viewData.depreciationCheckbox">
                <label>{{ 'object-info.depreciationMethod' | translate }} :</label>
                <p>{{viewData.depreciationMethod || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6" *ngIf="viewData.departmentCheckBox">
                <label>{{ 'object-info.assetLifeNumber' | translate }} :</label>
                <p>{{viewData.assetLifeNumber || '--'}}</p>
              </div>

              <div class="col-md-6 col-lg-6">
                <label>{{ 'object-info.asset_Category' | translate }} :</label>
                <p>{{viewData.asset_Category || '--'}}</p>
              </div>
              <div class="col-md-12 col-lg-12 qr-code">
                <label>{{ 'object-info.qr_code' | translate }} :</label>

                <qrcode [qrdata]="jsonString" [width]="150" [errorCorrectionLevel]="'M'"></qrcode>

              </div>


              <div class="col-md-12 col-lg-12">
                <div class="image-container" style="margin-top: 20px;">
                  <div class="image-header image-header1">
                    <h5>{{ 'object-info.images' | translate }}</h5>
                  </div>




                  <div class="image-content-block">
                    <div class="image-single" *ngFor="let image of imagesWithDetails;let i = index">
                      <p title="{{image.name}}">{{image.name}}</p>
                      <img src="{{image.image}}" (click)="selectLargeImage(image.image)" alt="">
                    </div>
                    <div class="large-image-view" *ngIf="largeImage != ''">
                      <img src="{{largeImage}}" alt="">
                      <button (click)="selectLargeImage('')">{{ 'generic.close' | translate }}</button>
                    </div>
                  </div>


                </div>
              </div>

              <div class="col-md-12 col-lg-12" *ngIf="viewData.nameValue && viewData.nameValue.length != 0">
                <h5 class="data-list-title">{{ 'object-info.nameValue' | translate }}</h5>
              </div>

              <div class="col-md-12 col-lg-12 data-list" *ngIf="viewData.nameValue && viewData.nameValue.length != 0">

                <div class="list-block">
                  <ul class="ui-tree">
                    <ng-container *ngFor="let item of viewData.nameValue">
                      <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: item }"></ng-container>
                    </ng-container>
                  </ul>

                  <ng-template #renderNode let-node>
                    <li>
                      <strong>{{ node.key }}:</strong> {{ node.value }}
                      <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                        <ng-container *ngFor="let child of node.keyValue">
                          <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: child }"></ng-container>
                        </ng-container>
                      </ul>
                    </li>
                  </ng-template>
                </div>
              </div>

              <div class="col-md-12 col-lg-12"
                *ngIf="viewData.performanceMatrix && viewData.performanceMatrix.length != 0">
                <h5 class="data-list-title">{{ 'object-info.performanceMatrix' | translate }}</h5>
              </div>

              <div class="col-md-12 col-lg-12" *ngIf="viewData.warranty && userCred.userType == 'Accounts'">
                <h5 class="data-list-title">{{ 'object-info.warranty' | translate }}</h5>
              </div>

              <div class="col-md-12 col-lg-12 data-list" *ngIf="viewData.warranty && userCred.userType == 'Accounts'">
                <div class="list-block">
                  <ul class="ui-tree">
                    <li *ngFor="let warrantyInfo of viewData.warrantyInfo">
                      <strong>{{ warrantyInfo.key }}:</strong> {{ warrantyInfo.value }}
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col-md-12 col-lg-12" *ngIf="viewData.warranty && userCred.userType == 'Accounts'">
                <h5 class="data-list-title">{{ 'object-info.purchase' | translate }}</h5>
              </div>

              <div class="col-md-12 col-lg-12 data-list" *ngIf="viewData.purchase && userCred.userType == 'Accounts'">
                <div class="list-block">
                  <ul class="ui-tree">
                    <li *ngFor="let purchaseInfo of viewData.purchaseInfo">
                      <strong>{{ purchaseInfo.key }}:</strong> {{ purchaseInfo.value }}
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col-md-12 col-lg-12 data-list"
                *ngIf="viewData.performanceMatrix && viewData.performanceMatrix.length != 0">

                <div class="list-block">
                  <ul class="ui-tree">
                    <ng-container *ngFor="let item of viewData.performanceMatrix">
                      <ng-container *ngTemplateOutlet="renderNode1; context: { $implicit: item }"></ng-container>
                    </ng-container>
                  </ul>

                  <ng-template #renderNode1 let-node>
                    <li>
                      <strong>{{ node.key }}:</strong> {{ node.value }}
                      <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                        <ng-container *ngFor="let child of node.keyValue">
                          <ng-container *ngTemplateOutlet="renderNode1; context: { $implicit: child }"></ng-container>
                        </ng-container>
                      </ul>
                    </li>
                  </ng-template>
                </div>
              </div>

              <div class="col-md-12 col-lg-12" style="padding: 0;"
                *ngIf="maintenanceScheduleList && maintenanceScheduleList.length != 0">
                <h5 class="maintenance-list-title">{{ 'maintenance-schedule.title' | translate }}</h5>

                <div class="maintenance-list-block">
                  <div class="list" *ngFor="let list of maintenanceScheduleList">

                    <div class="list1">
                      <div>
                        <label>{{ 'maintenance-schedule.maintenanceType' | translate }} :</label>
                        <p>{{getMaintenanceType(list.maintenanceType) || '--'}}</p>
                      </div>
                      <div>
                        <label>{{ 'maintenance-schedule.frequency' | translate }} :</label>
                        <p>{{list.frequency || '--'}}</p>
                      </div>
                      <div>
                        <label>{{ 'maintenance-schedule.nextDueDate' | translate }} :</label>
                        <p>{{list.nextDueDate || '--'}}</p>
                      </div>
                      <div>
                        <label>{{ 'maintenance-schedule.lastPerformed' | translate }} :</label>
                        <p>{{list.lastPerformed || '--'}}</p>
                      </div>
                    </div>
                    <div>
                      <label>{{ 'maintenance-schedule.description' | translate }} :</label>
                      <p>{{list.description || '--'}}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12 col-lg-12" style="padding: 0;"
                *ngIf="viewData.repairInfos && viewData.repairInfos.length != 0">
                <h5 class="repair-list-title">{{ 'object-info.repairList' | translate }} </h5>



                <div class="repair-list-block">
                  <div class="list" *ngFor="let list of viewData.repairInfos">
                    <div>
                      <p><label>{{ 'object-info.repairDone' | translate }} :</label> {{list.description || '--'}}</p>
                    </div>

                    <div class="dates">
                      <p><label>{{ 'object-info.repairGivenTo' | translate }} :</label> {{list.repairGivenTo || '--'}}
                      </p>
                      <p><label>{{ 'object-info.userName' | translate }} :</label> {{list.userName || '--'}}</p>
                      <p><label>{{ 'object-info.phNo' | translate }} :</label> {{list.phNo || '--'}}</p>
                      <p><label>{{ 'object-info.emailId' | translate }} :</label> {{list.emailId || '--'}}</p>
                      <p><label>{{ 'object-info.repairGivenDate' | translate }} :</label> {{list.repairGivenDate |
                        date}}</p>
                      <p><label>{{ 'object-info.repairExpectedEndDate' | translate }} :</label>
                        {{list.repairExpectedEndDate | date}}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12 col-lg-12" style="padding: 0;"
                *ngIf="viewData.assetHealth && viewData.assetHealth.length != 0">
                <h5 class="repair-list-title">{{ 'object-info.connections' | translate }}</h5>

                <div class="row">
                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.assetMonitoringFrequency' | translate }} :</label>
                    <p>{{viewData.assetMonitoringFrequency || '--'}}</p>
                  </div>

                  <div class="col-md-6 col-lg-6">
                    <label>{{ 'object-info.assetMonitoringTimeSpan' | translate }} :</label>
                    <p>{{viewData.assetMonitoringTimeSpan || '--'}}</p>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 col-lg-6" *ngFor="let connectionDetails of viewData.connectionDetails">
                    <label>{{connectionDetails.key || '--'}} :</label>
                    <p>{{connectionDetails.value || '--'}}</p>
                  </div>
                </div>
              </div>



              <div class="col-md-12 col-lg-12" style="padding: 0;"
                *ngIf="viewData.assetHealth && viewData.assetHealth.length != 0">
                <h5 class="repair-list-title">{{ 'object-info.assetHealth' | translate }}</h5>

                <div class="row">
                  <div class="col-md-6 col-lg-6" *ngFor="let assetHealthList of viewData.assetHealth">
                    <label>{{assetHealthList.key || '--'}} :</label>
                    <p>{{assetHealthList.value || '--'}}</p>
                  </div>
                </div>
              </div>


              <!-- 
              <div class="col-md-12 col-lg-12" style="padding: 0;" *ngIf="viewData.repairInfos && viewData.repairInfos.length != 0">
                <h5 class="repair-list-title">Repair List <span *ngIf="viewData.givenRepair" (click)="openRepairDone()">Repair Done</span></h5>
                
                <div class="repair-block" *ngIf="isRepairDone" [formGroup]="repairInfoForm">
                  <h5>Repair Done</h5>
                  <div class="form-group">
                    <label>Description</label>
                    <textarea name="" formControlName="description" id=""></textarea>
                  </div>

                  

                  <div class="action-repair">
                    <button type="button" class="btn btn-secondary" (click)="closeRepairDone()">Cancel</button>
                    <button type="button" (click)="addRepairInfos(false)" class="btn btn-primary">Repair Done</button>
                  </div>
                </div>


                <div class="repair-list-block">
                  <div class="list" *ngFor="let list of viewData.repairInfos">
                    <div>
                      <p><label>Description :</label> {{list.description || '--'}}</p>
                    </div>

                    <div class="dates">
                      <p><label>Company :</label> {{list.repairGivenTo || '--'}}</p>
                      <p><label>Name :</label> {{list.userName || '--'}}</p>
                      <p><label>Mobile :</label> {{list.phNo || '--'}}</p>
                      <p><label>Email :</label> {{list.emailId || '--'}}</p>
                      <p><label>Given Date :</label> {{list.repairGivenDate | date}}</p>
                      <p><label>Expected End Date :</label> {{list.repairExpectedEndDate | date}}</p>
                    </div>
                  </div>
                </div>
              </div> -->



              <div class="nameValue" *ngIf="viewData.performance">
                <div>
                  <h5 class="multi-title">{{ 'object-info.assetPerformance' | translate }}</h5>

                  <div class="row keys-content">

                    <div class="col-md-12 col-lg-12 keysBlock">
                      <div class="form-group">
                        <label for="">{{ 'object-info.timeSpan' | translate }}</label>
                        <p>{{viewData.assetPerformance?.timeSpan}}</p>

                      </div>

                      <div class="form-group">
                        <label for="">{{ 'object-info.uom' | translate }}</label>
                        <p>{{viewData.assetPerformance?.uom || '--'}}</p>
                      </div>

                      <div class="form-group">
                        <label for="">{{ 'object-info.expectedOutput' | translate }}</label>
                        <p>{{viewData.assetPerformance?.expectedOutput || '--'}}</p>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12 col-lg-12" style="padding: 0;" *ngIf="viewData.tags && viewData.tags.length != 0">
                <h5 class="repair-list-title">{{ 'object-info.tags' | translate }}</h5>
                <div class="tag-list">
                  <p class="tag" *ngFor="let list of viewData.tags">{{list}}</p>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton" (click)="remove()" class="btn btn-secondary"
            data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>